module.exports = __webpack_public_path__ + "assets/img/2415.bdd6174b.png";